import React, { useEffect } from "react";
import { List, ListItem, ListItemButton, ListItemText, ListItemIcon, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
// import {
//   getCustomerDashboard,
//   selectOtpState,
// } from "../../../../src/slice/customerDashboardSlice";
// import { clearUserDetails } from "../../../../src/slice/LoginPageSlice";
// import { setloginSliderstate } from "../../src/slice/LoginPageSlice";
import { getCustomerDashboard } from "../../../../Redux/Actions";

// SVG IMPORTS
import AddressIcon from "../../../../Assets/svg/address-active.svg";
import CardIcon from "../../../../Assets/svg/credit-card-active.svg";
import HelpIcon from "../../../../Assets/svg/help-active.svg";
import OrdersIcon from "../../../../Assets/svg/orders-active.svg";
import PresIcon from "../../../../Assets/svg/prescription-profile-menu-active.svg";
import WalletIcon from "../../../../Assets/svg/wallet-active.svg";
import FamilyFriendsIcon from "../../../../Assets/svg/family-friends-active.svg";
import GiftCardIcon from "../../../../Assets/svg/gift-card-active.svg";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { RiLogoutBoxLine } from "react-icons/ri";
// END SVG IMPORTS

import mobileProfileStyles from "./MobileProfileDrawer.module.css"

const MobileProfileDrawer = ({ setOpenProfileDrawer }) => {
  const menuItems = [
    {
      name: "Personal Information",
      href: "/userprofile",
      Icon: CardIcon,
    },
    {
      name: "My Orders",
      href: "/orders",
      Icon: OrdersIcon,
    },
    {
      name: "My Family & Friends",
      href: "/familyfriends",
      Icon: FamilyFriendsIcon,
    },
    {
      name: "My Addresses",
      href: "/myaddress",
      Icon: AddressIcon,
    },
    {
      name: "My Prescription",
      href: "/prescription",
      Icon: PresIcon,
    },
    {
      name: "My RedCash",
      href: "/myredcash",
      Icon: WalletIcon,
    },
    {
      name: "My Gift Card",
      href: "/subscription",
      Icon: GiftCardIcon,
    },
    {
      name: "Help & Support",
      href: "/helpandsupport",
      Icon: HelpIcon,
    },
  ];

  // const router = useRouter();
  const dispatch = useDispatch();
  const customerData = useSelector((state) => state.customerDashboard.packages);
  const customerDetails = customerData?.profile ?? {};

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const token = user?.token;
      if (token) {
        dispatch(getCustomerDashboard(token));
      }
    } catch {
      //console.log("User Details Not Found")
    }
  }, []);

  const handleItemClick = (href) => {
    window.location.href = process.env.RAZZLE_APP_BASE_URL + "/dashboard" + href;
    // router.push(`/dashboard${href}`);
  };

  const handleProfileDrawerClose = () => {
    document.getElementById("mobile-profile-menu").classList.add(mobileProfileStyles.slideOutRight);
    setTimeout(() => {
      setOpenProfileDrawer(false);
    }, 250);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    setOpenProfileDrawer(false);
    // dispatch(clearUserDetails());
    window.location.href = process.env.RAZZLE_APP_BASE_URL;
    // router.push("/");
  };

  return (
    <>
      <div
        className={`${mobileProfileStyles.slideInRight} ${mobileProfileStyles.mobileMenu}`}
        id="mobile-profile-menu"
      >
        <div className={mobileProfileStyles.topHeaderToggle}>
          <div className={mobileProfileStyles.iconContainer} onClick={handleProfileDrawerClose}>
            <ArrowBackIcon className={mobileProfileStyles.menuIcon} />
          </div>
          <span className={mobileProfileStyles.toggleHeadingMoble}>My Dashboard</span>
        </div>
        <div className={mobileProfileStyles.bottomHeaderToggle}>
          <div className={mobileProfileStyles.profileIconName}>
            {/* <div className={mobileProfileStyles.iconContainer}> */}
            {/* <img
              src={customerDetails?.image ? customerDetails?.image : "https://staticcdn.redcliffelabs.com/media/gallary-file/None/9dd91547-c9ff-46ef-96d1-1a4872969353.png"}
              alt="Image of User"
              width={50}
              height={40}
              style={{ borderRadius: "50%" }}
            /> */}
            {/* </div> */}
            <Typography
              variant="h4"
              component="h2"
              color="#0e3f6c"
              style={{
                fontFamily: "Jost",
                padding: "0 12px",
                fontWeight: "500",
                textTransform: "capitalize"
              }}
            >
              Hi,&nbsp;{customerDetails?.fullname ?? "Guest"}
            </Typography>
          </div>
          <div>
            <List style={{ marginTop: "1rem", border: "1px solid #ccc", borderRadius: "5px", padding: "0" }}>
              {menuItems.map(({ name, href, Icon }, index) => {
                return (
                  <ListItem
                    key={index}
                    style={{ borderBottom: "1px solid #ccc", padding: "0.5rem 1rem" }}
                    onClick={() => handleItemClick(href)}
                  >
                    <ListItemButton className={mobileProfileStyles.listButton}>
                      <ListItemIcon style={{ minWidth: "unset", marginRight: "1.5rem" }}>
                        <img src={Icon} style={{ width: "3rem", height: "auto" }} />
                      </ListItemIcon>
                      <ListItemText
                        sx={{
                          '& .MuiTypography-root': {
                            fontSize: "2rem",
                            fontFamily: "Jost",
                            color: "#707070"
                          }
                        }}
                      >
                        {name}
                      </ListItemText>
                      <ListItemIcon sx={{ alignSelf: "center", display: "flex", justifyContent: "flex-end", minWidth: "unset" }}>
                        <ArrowForwardIosIcon className={mobileProfileStyles.forwardIcon} />
                      </ListItemIcon>
                    </ListItemButton>
                  </ListItem>
                )
              })}
              <ListItem
                style={{ padding: "0.6rem 1.1rem" }}
                onClick={handleLogout}
              >
                <ListItemButton className={mobileProfileStyles.listButton}>
                  <ListItemIcon style={{ minWidth: "unset", marginRight: "1.5rem" }}>
                    <RiLogoutBoxLine style={{ fontSize: "3rem", color: "#e5184e" }} />
                  </ListItemIcon>
                  <ListItemText
                    sx={{
                      '& .MuiTypography-root': {
                        fontSize: "2rem",
                        fontFamily: "Jost",
                        color: "#707070"
                      }
                    }}
                  >
                    Logout
                  </ListItemText>
                  <ListItemIcon sx={{ alignSelf: "center", display: "flex", justifyContent: "flex-end", minWidth: "unset" }}>
                    <ArrowForwardIosIcon className={mobileProfileStyles.forwardIcon} />
                  </ListItemIcon>
                </ListItemButton>
              </ListItem>
            </List>
          </div>
        </div>
      </div >
    </>
  )
}

export default MobileProfileDrawer;
